import { render, staticRenderFns } from "./SelectGroup.vue?vue&type=template&id=40b5ebdf&scoped=true&"
import script from "./SelectGroup.vue?vue&type=script&lang=js&"
export * from "./SelectGroup.vue?vue&type=script&lang=js&"
import style0 from "./SelectGroup.vue?vue&type=style&index=0&id=40b5ebdf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b5ebdf",
  null
  
)

export default component.exports